import {apiWithToken} from '../../systems/api';
import {API_URL} from './../../systems/globalContant';

export default {
    resolve: (transactionId, data = {}) => apiWithToken.put(API_URL.DEFAULT + `/transactions/${transactionId}/resolve`, data, {loading: false}),
    unresolve: (transactionId) => apiWithToken.put(API_URL.DEFAULT + `/transactions/${transactionId}/unresolve`, {}, {loading: false}),
    updateNote: (transactionId, data = {}) => apiWithToken.put(API_URL.DEFAULT + `/transactions/${transactionId}/note`, data, {loading: false}),
    mark: (transaction_id, data = {}) => apiWithToken.put(API_URL.DEFAULT + `/transactions/${transaction_id}/is-not-ok`, data, {loading: false}),
};
